import http from '@/axios'

// 查询权限id
export function getRulesId(params, config = {}) {
    const url = '/getRulesId'
    return http.get(url, params, config)
}

// 获取菜单数据
export function getMenus(params, config = {}) {
    const url = '/getMenus2'
    return http.get(url, params, config)
}
